var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
document.addEventListener("turbo:load", () => __async(this, null, function* () {
  const GRANTED_PERMISSION = "granted";
  const hideReminder = function() {
    const reminder = document.querySelector("[data-push-notifications-reminder]");
    if (!reminder) {
      return;
    }
    reminder.classList.add("hide");
  };
  const showError = (message) => {
    const container = document.querySelector("[data-push-notifications-container]");
    if (!container) {
      return;
    }
    const existingError = container.querySelector("[data-push-notifications-error]");
    if (existingError) {
      existingError.remove();
    }
    const errorElement = document.createElement("div");
    errorElement.dataset.pushNotificationsError = "true";
    errorElement.classList.add("flash", "alert", "push-notifications__error");
    errorElement.innerText = message;
    container.prepend(errorElement);
  };
  const subscribeToNotifications = (registration) => __async(this, null, function* () {
    var _a;
    const permission = yield window.Notification.requestPermission();
    if (registration && permission === GRANTED_PERMISSION) {
      const vapidElement = document.querySelector("[data-push-vapid-public-key]");
      if (vapidElement) {
        const vapidPublicKeyElement = JSON.parse(vapidElement.value);
        const subscription = yield registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: new Uint8Array(vapidPublicKeyElement)
        });
        if (subscription) {
          const response = yield fetch("/notifications_subscriptions", {
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": (_a = document.querySelector("meta[name=csrf-token]")) == null ? void 0 : _a.content
            },
            method: "POST",
            body: JSON.stringify(subscription)
          });
          if (!response.ok) {
            const body = yield response.json();
            throw new Error(body.error);
          }
        }
      }
      hideReminder();
    } else {
      throw new Error("Permission not granted for Notification");
    }
  });
  const unsubscribeFromNotifications = (registration) => __async(this, null, function* () {
    var _a;
    const currentSubscription = yield registration.pushManager.getSubscription();
    const auth = currentSubscription.toJSON().keys.auth;
    yield fetch(`/notifications_subscriptions/${auth}`, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": (_a = document.querySelector("meta[name=csrf-token]")) == null ? void 0 : _a.content
      },
      method: "DELETE"
    });
  });
  const setToggleState = (registration, toggle) => __async(this, null, function* () {
    const currentSubscription = yield registration.pushManager.getSubscription();
    let toggleChecked = false;
    if (window.Notification.permission === GRANTED_PERMISSION) {
      hideReminder();
      if (currentSubscription) {
        const auth = currentSubscription.toJSON().keys.auth;
        const subKeysElement = document.querySelector("[data-push-sub-keys]");
        if (subKeysElement) {
          const subKeys = JSON.parse(subKeysElement.value);
          if (subKeys.includes(auth)) {
            toggleChecked = true;
          }
        }
      }
    }
    toggle.checked = toggleChecked;
  });
  if ("serviceWorker" in navigator) {
    const toggle = document.querySelector("[data-push-notifications-toggle]");
    if (toggle) {
      const registration = yield navigator.serviceWorker.ready;
      setToggleState(registration, toggle);
      toggle.addEventListener("change", (_0) => __async(this, [_0], function* ({ target }) {
        try {
          if (target.checked) {
            yield subscribeToNotifications(registration);
          } else {
            yield unsubscribeFromNotifications(registration);
          }
        } catch (error) {
          target.checked = false;
          showError(error.message);
        }
      }));
    }
  }
}));
